import template from './admin.html';
import controller from './admin.controller';

let adminComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default adminComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/admin.component.js